import { render, staticRenderFns } from "./ReturnedGoodsOfUserTable.vue?vue&type=template&id=14ee0524&scoped=true"
import script from "./ReturnedGoodsOfUserTable.vue?vue&type=script&lang=js"
export * from "./ReturnedGoodsOfUserTable.vue?vue&type=script&lang=js"
import style0 from "./ReturnedGoodsOfUserTable.vue?vue&type=style&index=0&id=14ee0524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ee0524",
  null
  
)

export default component.exports